// extracted by mini-css-extract-plugin
export default {"root":"_1DDeM","body-wrapper":"dacBt","bodyWrapper":"dacBt","big":"_1LipP","postfix":"_2lXlX","small":"_2hcAs","multiline":"E5j17","body-node":"_2SY0Y","bodyNode":"_2SY0Y"};